import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  inputAutocomplete: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,

    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& .MuiOutlinedInput-input': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& span': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      fontSize: '1rem',
      fontFamily: 'Inter, sans-serif',
      fontWeight: '400',
      lineWeight: '1'
    }
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  optionText: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50?.main || '#fff'
        : theme.palette.gray_400?.main || '#444',
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.9rem'
  },
}))
